import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as RasaInput from '../../components/rasa-input'
import * as Request from '../../request'
import * as Utils from '../../utils'
import * as Types from './types'

export const FETCH_POSTS = Utils.join(Request.SWITCH, 'FETCH_POSTS')
export const FETCH_POSTS_SORTED = Utils.join(Request.SWITCH, 'FETCH_POSTS_SORTED')
export const FETCH_RECENT_ISSUES = 'FETCH_RECENT_ISSUES'

export const RATE_POST = 'RATE_POST'
export const CONTENT_TYPE = 'Content'

export const ADD_POST = 'ADD_POST'
export const POST_FORM = 'POST_FORM'
export const UPDATE_POST = 'UPDATE_POST'
export const EDIT_POST = 'EDIT_POST'
export const EDIT_POST_FORM = 'EDIT_POST_FORM'

export const SHOW_POSTS = 'CONTENT-Posts'
export const SHOW_SOURCES = 'CONTENT-Sources'
export const SHOW_LEAD_POSTS = 'CONTENT-LeadPosts'
export const SHOW_PROMOTIONS = 'CONTENT-Promotions'

export const SERVER_RESOURCE = '/posts'
export const PAGE_PREFIX = 'POSTS'
export const SELECT_POSTS_DATE_RANGE = `SELECT_POSTS_DATE_RANGE`
export const SELECT_POSTS_DATE_RANGE_AND_FILTER = `SELECT_POSTS_DATE_RANGE_AND_FILTER`

export const POST_MAX_RESULTS = 1000
export const SERVER_PAGE_SIZE = 100
export const POSTS_SERVER_SORT = 'POSTS_SERVER_SORT'

export const SORT_BY = {
  Asc: 'asc',
  Desc: 'desc',
}

export const MANUALLY_CHANGED_FILTER: IsActive.Filter = {
  description: 'Show manually changed posts',
  key: 'status',
  value: 'changed',
}

export const RECOMMENDATIONS_FILTER: IsActive.Filter = {
  description: 'Show AI recommendations',
  key: 'status',
  value: 'recommendations',
}

export const filterParameters = IsActive.StatusFilterParameters
  .concat([MANUALLY_CHANGED_FILTER])

export const CHANGE_DATE_SELECT = 'CHANGE_DATE_SELECT'

export const DATE_SELECT_LAST_NEWSBRIEF_MODE = 'lastNewsbrief'
export const DATE_SELECT_DATE_RANGE_MODE = 'dateRange'
export const ISSUES_SELECT_ALL_ARTICLES_MODE = 'allArticles'

export const DATE_SELECT_LAST_NEWSBRIEF: IsActive.Filter = {
  description: 'Since last newsletter',
  key: 'mode',
  value: DATE_SELECT_LAST_NEWSBRIEF_MODE,
}
export const DATE_SELECT_DATE_RANGE: IsActive.Filter = {
  description: 'Selected date range',
  key: 'mode',
  value: DATE_SELECT_DATE_RANGE_MODE,
}
export const ALL_ARTICLES: IsActive.Filter = {
  description: 'Show all past articles',
  key: 'mode',
  value: ISSUES_SELECT_ALL_ARTICLES_MODE,
}
export const dateSelectFilters = [DATE_SELECT_LAST_NEWSBRIEF, DATE_SELECT_DATE_RANGE]

export const FormFieldNames = {
  Description: 'description',
  ImageUrl: 'image_url',
  SiteName: 'site_name',
  Title: 'title',
}

export const emptyFormField: Types.FormFields = {
  description: '',
  id: null,
  image_url: '',
  link_url: '',
  site_name: '',
  title: '',
  url: '',
}

export const FormValidators: Form.FormValidators = {
  [FormFieldNames.ImageUrl]: RasaInput.validateOptionalForgivingUrl,
  [FormFieldNames.Title]: RasaInput.validatePresent,
}

export const TITLE = 'title'
export const AI_RECOMMENDATIONS = 'ai_recommendations'
export const RECOMMENDATIONS = 'recommendations'



// WEBPACK FOOTER //
// ./src/pages/posts/constants.ts